// Variant denomination buttons on collection cards
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.variant-btn');
  if (!btn || btn.disabled) return;

  var productId = btn.dataset.productid;
  var variantId = btn.dataset.variantId;
  var variantPrice = btn.dataset.variantPrice;

  // Update active state
  var group = btn.closest('.variant-btns');
  group.querySelectorAll('.variant-btn').forEach(function (b) {
    b.classList.remove('active');
  });
  btn.classList.add('active');

  // Sync hidden select
  var select = document.querySelector('select[data-productid="' + productId + '"]');
  if (select) {
    select.value = variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Update price display
  var priceDisplay = document.querySelector('[data-price-display="' + productId + '"]');
  if (priceDisplay && variantPrice) {
    var priceItem = priceDisplay.querySelector('.price-item--regular, .price-item--sale');
    if (priceItem) priceItem.textContent = variantPrice;
  }
});
